export const MAIN_TAB_ID = 'main';
export const ENGAGEMENT_TAB_ID = 'engagement';
export const RESPONDENTS_TAB_ID = 'respondents';
export const SUBMISSIONS_TAB_ID = 'submissions';
